import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Modal from "react-responsive-modal";
import { Row, Col, TabContent, TabPane } from "reactstrap";
import StarRatingComponent from "react-star-rating-component";
import { messages } from "../../constants/messages";
import { showMessage } from "../../actions/FlashMessageActions";
import { getGameDetail, getSimilarGames } from "../../actions/GamesActions";
import { show, hide } from "../../actions/ActivityIndicatorActions";
import { appendUid } from "../../utils/helper";
import { FormattedMessage } from "react-intl";
import { config } from "../../constants/domainConfig";
import { sendData } from "../../analytics/sendData";
import { isGamiclub } from "./../../constants/isGamiclub";
import { isGameflares, isGamiway } from "../../constants/productCondition";

let msg = messages;

class GameDetailDemo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: "1",
      rating: 0,
      liked: 0,
      isFavorite: 0,
      categoryId: 0,
      gameId: 0,
      openGame: false,
      game: "",
      open: false,
    };
    this.toggle = this.toggle.bind(this);
    this._openGame = this._openGame.bind(this);
    this.loadGame = this.loadGame.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    sendData(
      this.state.game.gameTitle,
      this.state.game.categoryName,
      this.state.game.gameType,
      "viewed",
      { page: "game page" }
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.openGame && prevState.gameId != this.state.gameId) {
      sendData(
        prevState.game.gameTitle,
        prevState.game.categoryName,
        prevState.game.gameType,
        "finished"
      );
      sendData(
        this.state.game.gameTitle,
        this.state.game.categoryName,
        this.state.game.gameType,
        "played"
      );
    } else if (!this.state.openGame && prevState.gameId != this.state.gameId) {
      sendData(
        this.state.game.gameTitle,
        this.state.game.categoryName,
        this.state.game.gameType,
        "viewed"
      );
    }
  }

  componentWillMount() {
    let gameId = this.props.match.params.gameId;
    let uid = this.props.access.uid;
    this.getGameDetail(gameId, uid);
  }

  componentWillUnmount() {
    if (this.state.openGame) {
      sendData(
        this.state.game.gameTitle,
        this.state.game.categoryName,
        this.state.game.gameType,
        "finished"
      );
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.match.params.gameId != nextProps.match.params.gameId) {
      this.getGameDetail(nextProps.match.params.gameId, this.props.access.uid);
    }
  }

  onOpenModal() {
    this.setState({ open: true });
  }

  onCloseModal() {
    this.setState({ open: false });
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  getGameDetail(gameId, uid) {
    let allGames = this.props.game.games;
    let foundGame = allGames.find((game) => {
      return game.gameId == gameId;
    });
    this.props.getGameDetail(foundGame);
    this.setState({
      game: foundGame,
      gameId: gameId,
      categoryId: foundGame ? foundGame.categoryId : 0,
      isFavorite: foundGame ? (foundGame.isFavorite ? 1 : 0) : 0,
      liked: foundGame ? (foundGame.liked ? 1 : 0) : 0,
    });
  }

  _openGame(game, e) {
    e.preventDefault();
    this.props.history.push(
      appendUid("/play-maxis/" + game.gameId, this.props.access.uid)
    );
  }
  loadGame() {
    sendData(
      this.state.game.gameTitle,
      this.state.game.categoryName,
      this.state.game.gameType,
      "played"
    );
    this.props.show();
    this.setState({
      openGame: !this.state.openGame,
    });
    setTimeout(() => {
      this.props.hide();
    }, 1000);
  }

  render() {
    const gameDetail = this.state.game;

    const bgImages = [
      "",
      "rpg",
      "augmented-reality",
      "virtual-reality",
      "action",
      "adventure",
      "arcade",
      "racing",
      "sports",
      "utilities",
      "action",
      "adventure",
      "arcade",
      "racing",
      "sports",
      "rts",
      "",
      "premium",
      "premium",
      "",
      "premium",
      "premium",
    ];

    const { open } = this.state;

    return (
      <section className="game-detail">
        <div className="container-fluid">
          {!this.state.openGame ? (
            <Row className="clearfix">
              <Col xs="12" className="mb-4 px-0">
                <TabContent activeTab={this.state.activeTab}>
                  {gameDetail != null ? (
                    <TabPane tabId="1">
                      <Row
                        className={
                          "game-bg-image " + bgImages[gameDetail.categoryId]
                        }
                      >
                        <Col
                          lg="3"
                          xs="12"
                          className="text-right top-z-index game-thumb-wrap"
                        >
                          <img
                            className="img-fluid game-thumb"
                            src={
                              gameDetail.gameImage.includes(
                                "https://cdn.game-lords.com/games/http"
                              )
                                ? gameDetail.gameImage.split(
                                    "https://cdn.game-lords.com/games/"
                                  )[1]
                                : gameDetail.gameImage
                            }
                            alt={gameDetail.gameTitle}
                          />
                        </Col>
                        <Col
                          lg="9"
                          xs="12"
                          className="top-z-index game-top-wrap"
                        >
                          <div className="game-detail-top">
                            <div className="game-title-rating">
                              <h3 className="game-detail-title">
                                <FormattedMessage
                                  id={`${gameDetail.gameTitle.toUpperCase()}`}
                                  defaultMessage={gameDetail.gameTitle}
                                />
                              </h3>

                              <StarRatingComponent
                                name="rate1"
                                starCount={5}
                                value={gameDetail.userRating}
                                editing={false}
                                renderStarIcon={() => (
                                  <i
                                    style={
                                      isGamiclub
                                        ? { color: "green" }
                                        : isGameflares
                                        ? { color: "#FF394B" }
                                        : isGamiway
                                        ? { color: "#b347a0" }
                                        : null
                                    }
                                    className="fa fa-star custom-star"
                                  ></i>
                                )}
                              />
                            </div>
                          </div>
                          <div id="contentMob">
                            <a
                              className="game-btn text-shadow-small"
                              onClick={this.loadGame}
                            >
                              <FormattedMessage
                                id="playNow"
                                defaultMessage="Play Now"
                              />
                            </a>
                          </div>
                          <div id="contentDes">
                            <a
                              className="game-btn text-shadow-small"
                              onClick={this.loadGame}
                            >
                              <FormattedMessage
                                id="playNow"
                                defaultMessage="Play Now"
                              />
                            </a>
                          </div>
                          <div className="game-description">
                            <div className="game-desc-list"></div>
                          </div>
                        </Col>
                      </Row>
                    </TabPane>
                  ) : (
                    <TabPane tabId="1">
                      <p className="no-game-text">Game not found!</p>
                    </TabPane>
                  )}
                </TabContent>
              </Col>
            </Row>
          ) : (
            <div style={{ objectFit: "cover" }}>
              <object data={gameDetail.gameFile} className="openGame"></object>
              <h3 style={{ padding: "20px 0px" }}>
                <FormattedMessage
                  id={`${gameDetail.gameTitle.toUpperCase()}`}
                  defaultMessage={gameDetail.gameTitle}
                />
              </h3>
            </div>
          )}
        </div>
        <Modal open={open} onClose={this.onCloseModal.bind(this)} center>
          <h5 className="modelHeading">Incompatible Device</h5>
          <p>Device is not compatible with the file</p>
          <a
            className="modelAnchor"
            href={appendUid("/#/home/html", this.props.access.uid)}
          >
            <button className="modelButton">Okay</button>
          </a>
        </Modal>
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    game: state.GamesReducer,
    access: state.WelcomeReducer,
    header: state.HeaderReducer,
    search: state.SearchReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      show,
      hide,
      getGameDetail,
      getSimilarGames,
      showMessage,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(GameDetailDemo);



// WEBPACK FOOTER //
// ./src/components/GameDetail/GameDetailDemo.js